import { AppConfig } from '../../../app-config'
import getUserDetails from '../../../utils/actions/getUserDetails'
import { getLeadSource } from '../../../utils/analytics/leadSourceHelper'
import { triggerSimpleAjax } from '../../../utils/http-helper'
import {
	EVENT_ITINERARY_COSTING_SUBMITTED,
	USER_LOGIN_GETCOST,
} from '../../../utils/ML/EventsTracker'

const API_URL = AppConfig.api_url

export const triggerLoginWithOTP = ({
	reqObj = {},
	successSubmitCallback,
	failureSubmitCallback,
	router,
	lastLocation,
	eventProps = {},
	dispatch,
}) => {
	let url = `${API_URL}user/forgetpassword/verifyotp`
	return new Promise((resolve, reject) => {
		triggerSimpleAjax({
			url,
			method: 'POST',
			body: reqObj,
			onSuccess: response => {
				if (response.status === 'SUCCESS') {
					const leadSource = getLeadSource({
						router,
						lastLocation,
					})
					eventProps.prod_type = leadSource?.prodType
					getUserDetails({
						req_data: { prod_type: leadSource.prodType },
						authType: USER_LOGIN_GETCOST,
						triggerMultipleEvents: [
							{
								event: EVENT_ITINERARY_COSTING_SUBMITTED,
								eventProps: eventProps,
							},
						],
						dispatch,
						router,
					})
						.then(userDetails => {
							successSubmitCallback({ ...userDetails, router })
							resolve()
						})
						.catch()
				} else if (
					response.status === 'VERIFICATION_FAILED' ||
					response.status === 'EXPIRED'
				) {
					// setLoginStatus(response.status, response.message);
					failureSubmitCallback({
						otp: response.message,
						message: response.message,
						status: response.status,
					})
					reject(new Error(response.status))
				} else {
					failureSubmitCallback({
						mobileNumber: 'Unable to Login. Please try again later.',
						message: 'Unable to Login. Please try again later.',
						status: response.status,
					})
					reject(new Error('Login Failed'))
				}
			},
			onFailure: error => {
				failureSubmitCallback({
					mobileNumber: 'Unable to Login. Please try again later.',
				})
				reject(error)
			},
		})
	})
}
